import React, { useEffect, useState } from 'react';
import './HamburgerMenu.css';
import { BsList, BsXLg, BsFillPrinterFill, BsDatabase, BsFileText, BsQuestionCircle, BsMegaphone, BsBook, BsHouse } from 'react-icons/bs';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { isAreaCalcControlOpenAtom, isDistanceControlOpenAtom, isDownloadControlerOpenAtom, isDrawControlOpenAtom, isPrinterControlOpenAtom, isSeparateDisplayControllerAtom, selectedBaseMapAtom, selectedMapIdAtom, sidebarHeightAtom, tOSViewStateAtom, ViewState } from '../../atoms';
import classNames from 'classnames';
import { FormatText } from '../../lib/FormatText';
import IconButton from '../button/IconButton';
import { BiDownload, BiPaint, BiRuler, BiSolidBook } from 'react-icons/bi';
import ReactGA from 'react-ga4';
import { RiRuler2Line } from 'react-icons/ri';
import ToggleButton from '../button/hamburgerMenu/ToggleButton';
import { noticeCsvToArray, sortByDateDesc } from '../../types/lib/arrayUtils';



type NoticeType = {
    'タイトル': string,
    '詳細': string,
    '掲載開始日時': string,
    '掲載終了日時': string
}

type HamburgerMenuProps = {
    isDesktop: boolean;
};

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ isDesktop }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [noticeArr, setNoticeArr] = useState<NoticeType[] | undefined>(undefined);

    // atoms
    const [isDownloadControlerOpen, setIsDownloadControlerOpen] = useAtom(isDownloadControlerOpenAtom);
    const [isPrinterControlOpen, setIsPrinterControlOpen] = useAtom(isPrinterControlOpenAtom);
    const isSeparateDisplayController = useAtomValue(isSeparateDisplayControllerAtom);

    const setSidebarHeight = useSetAtom(sidebarHeightAtom);       // サイドバー開け閉め（スマホ）

    const [isDistanceControlOpen, setIsDistanceControlOpen] = useAtom(isDistanceControlOpenAtom);
    const [isAreaCalcControlOpen, setIsAreaCalcControlOpen] = useAtom(isAreaCalcControlOpenAtom);
    const [isDrawControlOpen, setIsDrawControlOpen] = useAtom(isDrawControlOpenAtom);
    const setTOSViewState = useSetAtom(tOSViewStateAtom);
    const selectedBaseMap = useAtomValue(selectedBaseMapAtom);

    const selectedMapId = useAtomValue(selectedMapIdAtom);

    const toggleMenu = () => { setIsOpen(!isOpen) };

    /* 画像出力 */
    const exportImage = () => {
        //【GoogleAnalytics】画像出力ボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/画像出力',       // ボタン名
        });

        setIsDownloadControlerOpen(true);
        setIsOpen(false);
    };
    /* 印刷 */
    const print = () => {
        //【GoogleAnalytics】印刷ボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/印刷',       // ボタン名
        });

        setIsPrinterControlOpen(true);
        setIsOpen(false);
    };

    /* 描く */
    const draw = () => {
        //【GoogleAnalytics】描くボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/描く',       // ボタン名
        });

        setIsDrawControlOpen((prev) => {
            if (prev === selectedMapId) { return undefined; }
            return selectedMapId;
        });
        setIsAreaCalcControlOpen(undefined);
        setIsDistanceControlOpen(undefined);
        setIsOpen(false);
    };
    /* 距離計測 */
    const distanceMeasurement = () => {
        //【GoogleAnalytics】距離計測ボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/距離計測',       // ボタン名
        });
        setIsDistanceControlOpen((prev) => {
            setSidebarHeight('close');
            if (prev === selectedMapId) { return undefined; }
            return selectedMapId;
        });
        setIsDrawControlOpen(undefined);
        setIsAreaCalcControlOpen(undefined);
        setIsOpen(false);
    };
    /* 面積計測 */
    const areaMeasurement = () => {
        //【GoogleAnalytics】面積計測ボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/面積計測',       // ボタン名
        });
        setIsAreaCalcControlOpen((prev) => {
            setSidebarHeight('close');
            if (prev === selectedMapId) { return undefined; }
            return selectedMapId;
        });
        setIsDrawControlOpen(undefined);
        setIsDistanceControlOpen(undefined);
        setIsOpen(false);
    }


    /* 使い方 */
    const openManuel = () => {
        //【GoogleAnalytics】オープンデータボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/スマートマップ焼津使い方',       // ボタン名
        });

        window.open('https://yaizu-smartcity.jp/smartmap_manual.pdf', '_blank');
    };

    /* ポータルサイト */
    const openPortalSite = () => {
        //【GoogleAnalytics】ポータルサイトボタン クリックトラッキング
        ReactGA.event({
            category: "button_click",           // カテゴリ（任意の名前）
            action: "click",                    // イベントの種類
            label: 'メニュー右/ポータルサイト',     // ボタン名
        });

        window.open('https://yaizu-smartcity.jp/', '_blank')
    };

    /* オープンデータ */
    const openOpenData = () => {
        //【GoogleAnalytics】オープンデータボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/オープンデータ',       // ボタン名
        });

        window.open('https://github.com/yaizu-city/opendata#yaizu-open-data', '_blank')
    };

    /* ドキュメント */
    const openDevDoc = () => {
        //【GoogleAnalytics】ドキュメントボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/ドキュメント',       // ボタン名
        });
        window.open('https://docs.yaizu-smartcity.jp', '_blank')
    };

    /* 利用規約 */
    const openTOS = () => {
        //【GoogleAnalytics】利用規約ボタン クリックトラッキング
        ReactGA.event({
            category: 'click_button',
            action: 'click_button_メニュー右/',
        });
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/利用規約',       // ボタン名
        });

        setTOSViewState(ViewState.SubsequentView);
    };

    /* お問い合わせ */
    const openContact = () => {
        //【GoogleAnalytics】お問い合わせボタン クリックトラッキング
        ReactGA.event({
            category: "button_click", // カテゴリ（任意の名前）
            action: "click",          // イベントの種類
            label: 'メニュー右/お問い合わせ',       // ボタン名
        });

        window.open('https://logoform.jp/form/tWbQ/206951', '_blank')
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('https://raw.githubusercontent.com/yaizu-city/app/main/お知らせ.csv');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const text = await response.text();
                const parsedData = noticeCsvToArray(text) as unknown as NoticeType[];

                // 掲載開始日時が新しい順に並べ替え
                const sortedData = sortByDateDesc(parsedData, '掲載開始日時');
                setNoticeArr(sortedData);
            } catch (error) {
                console.error('Fetch error:', error);
            }
        };

        fetchData();

    }, []);
                            

    /* ******************
     * ボタン情報 
     * ******************/
    const exportBtnInfo = [
        {
            label: '画像出力',
            function: () => exportImage(),
            icon: <BiDownload />,
            selectedFlag: isDownloadControlerOpen,
            disabled: selectedBaseMap?.isCustom || isSeparateDisplayController
        },
        {
            label: '印刷',
            function: () => print(),
            icon: <BsFillPrinterFill />,
            selectedFlag: isPrinterControlOpen,
            spHidden: true,
            disabled: isSeparateDisplayController
        },
    ];

    const drawsBtnInfo = [
        {
            label: '描く',
            function: () => draw(),
            icon: <BiPaint />,
            selectedFlag: isDrawControlOpen,
            spHidden: true
        },
        {
            label: '距離計測',
            function: () => distanceMeasurement(),
            icon: <BiRuler />,
            selectedFlag: isDistanceControlOpen
        },
        {
            label: '面積計測',
            function: () => areaMeasurement(),
            icon: <RiRuler2Line />,
            selectedFlag: isAreaCalcControlOpen
        }
    ];

    const documentBtnInfo = [
        {
            label: '焼津市スマートマップ使い方',
            function: () => openManuel(),
            icon: <BsBook />
        },
        {
            label: 'ポータルサイト',
            function: () => openPortalSite(),
            icon: <BsHouse />
        },
        {
            label: 'オープンデータ一覧',
            function: () => openOpenData(),
            icon: <BsDatabase />
        },
        {
            label: '開発者向けドキュメント',
            function: () => openDevDoc(),
            icon: <BiSolidBook />,
        },
        {
            label: '利用規約',
            function: () => openTOS(),
            icon: <BsFileText />
        }
    ];


    return (
        <div className={classNames('hamburger-menu', { 'open': isOpen, 'smartphone': isDesktop })}>
            <button data-e2e-test-id="hamburger-btn" className='hamburger-icon' onClick={toggleMenu}>
                {
                    (!isDesktop && noticeArr && noticeArr.length > 0 && !isOpen)
                    && <div className='icon-button-badge' style={{ top: 0, right: '-3px' }} />
                }
                {isOpen ? <BsXLg /> : <BsList />}
            </button>
            <div className='menu-content'>
                <div className='notice-container'>
                    {isOpen && <p className='container-title'>お知らせ</p>}
                    {isOpen ? <div className='notice-list'>
                        {(noticeArr && noticeArr.length > 0) ?
                            noticeArr.map((notice, index) => (
                                <div key={index} className='notice-item'>
                                    <p className='date'>{notice['掲載開始日時']}</p>
                                    <p className='title'><FormatText text={notice['タイトル']} /></p>
                                    <p className='description'><FormatText text={notice['詳細']} /></p>
                                </div>
                            ))
                            :
                            <p>お知らせはありません。</p>
                        }
                    </div>
                        :
                        <IconButton
                            color='white'
                            onClick={toggleMenu}
                            icon={<BsMegaphone />}
                            iconType='square'
                            backgroundColor='skeleton'
                            tooltip='お知らせ'
                            showBadge={noticeArr && noticeArr.length > 0} label={''}
                        />
                    }
                </div>
                <hr />
                <div className='btn-container'>
                    {isOpen && <p className='container-title'>出力機能</p>}
                    <div className='btn-list'>
                        {
                            exportBtnInfo.map((btn, index) => (
                                btn.spHidden && !isDesktop ? 
                                    null
                                :
                                    <ToggleButton 
                                        key={index}
                                        isOpen={isOpen} 
                                        onClick={btn.function}
                                        fullWidth
                                        label={btn.label}
                                        backgroundColor='skeleton'
                                        bold={true}
                                        tooltip={btn.label}
                                        color='white'
                                        iconType='square'
                                        icon={btn.icon}
                                        selected={btn.selectedFlag}
                                        disabled={btn.disabled}
                                    />
                            ))
                        }
                    </div>
                </div>

                <div className='btn-container'>
                    {isOpen && <p className='container-title'>計測・作図</p>}
                    <div className='btn-list'>
                        {
                            drawsBtnInfo.map((btn, index) => (
                                btn.spHidden && !isDesktop ? 
                                    null
                                :
                                    <ToggleButton 
                                        key={index}
                                        isOpen={isOpen} 
                                        onClick={btn.function}
                                        fullWidth
                                        label={btn.label}
                                        backgroundColor='skeleton'
                                        bold={true}
                                        tooltip={btn.label}
                                        color='white'
                                        iconType='square'
                                        icon={btn.icon}
                                        selected={btn.selectedFlag !== undefined}
                                    />
                            ))
                        }
                    </div>
                </div>

                <div className='btn-container'>
                    {isOpen && <p className='container-title'>ドキュメント</p>}
                    <div className='btn-list'>
                        {
                            documentBtnInfo.map((btn, index) => (
                                <ToggleButton 
                                    key={index}
                                    isOpen={isOpen} 
                                    onClick={btn.function}
                                    fullWidth
                                    label={btn.label}
                                    backgroundColor='skeleton'
                                    bold={true}
                                    tooltip={btn.label}
                                    color='white'
                                    iconType='square'
                                    icon={btn.icon}
                                />
                            ))
                        }
                    </div>
                </div>
                <div className='btn-container'>
                    <ToggleButton 
                        isOpen={isOpen} 
                        onClick={openContact}
                        fullWidth
                        label='お問い合わせ'
                        backgroundColor='skeleton'
                        bold={true}
                        tooltip='お問い合わせ'
                        color='white'
                        iconType='square'
                        icon={<BsQuestionCircle />}
                        e2eTestId='sidebar-contact-btn'
                    />
                </div>
            </div>
        </div>
    );
};

export default HamburgerMenu;

